import { ArgumentNullError, InvalidParameterError } from "./errors";
var Range = /** @class */ (function () {
    function Range(_a) {
        var from = _a.from, to = _a.to;
        this.to = to;
        this.from = from;
        if (from > to) {
            throw new InvalidParameterError("'from' > 'to' when it should be the opposite. Got 'to' " + to + ", 'from': " + from);
        }
    }
    Range.prototype.contains = function (point) {
        return point >= this.from && point <= this.to;
    };
    Range.prototype.intersect = function (range) {
        return (this.contains(range.from) ||
            this.contains(range.to) ||
            range.contains(this.from) ||
            range.contains(this.to));
    };
    return Range;
}());
export { Range };
function assertIsValidPosition(position) {
    if (!position) {
        throw ArgumentNullError.fromName("position");
    }
    if (!(position.x instanceof Range)) {
        throw InvalidParameterError.fromName("position.x", "expected instance of Range");
    }
    if (!(position.y instanceof Range)) {
        throw InvalidParameterError.fromName("position.y", "expected instance of Range");
    }
    // no need to check both from and to, because 'to >= from' is enforced by Range
    if (position.x.from < 0) {
        throw InvalidParameterError.fromName("position.x.from", "must be >= 0, got " + position.x.from);
    }
    if (position.y.from < 0) {
        throw InvalidParameterError.fromName("position.x.from", "must be >= 0, got " + position.y.from);
    }
}
var Rect = /** @class */ (function () {
    function Rect(props) {
        assertIsValidPosition(props);
        this.x = props.x;
        this.y = props.y;
        Object.freeze(this);
    }
    Rect.fromSize = function (sizedPosition) {
        if (!sizedPosition) {
            throw ArgumentNullError.fromName("sizedPosition");
        }
        if (typeof sizedPosition.width !== "number") {
            throw InvalidParameterError.fromName("sizedPosition.width", "got " + typeof sizedPosition.width + ", expected number");
        }
        if (typeof sizedPosition.height !== "number") {
            throw InvalidParameterError.fromName("sizedPosition.height", "got " + typeof sizedPosition.height + ", expected number");
        }
        var x = sizedPosition.x, y = sizedPosition.y, width = sizedPosition.width, height = sizedPosition.height;
        return new Rect({
            x: new Range({ from: x, to: x + width }),
            y: new Range({ from: y, to: y + height })
        });
    };
    Rect.fromLegacy = function (legacy) {
        return Rect.fromSize({
            x: legacy.x,
            y: legacy.y,
            width: legacy.xEnd - legacy.x,
            height: legacy.yEnd - legacy.y
        });
    };
    Rect.prototype.isCollidingWith = function (p1) {
        assertIsValidPosition(p1);
        return ((this.x.contains(p1.x.from) || this.x.contains(p1.x.to)) &&
            (this.y.contains(p1.y.from) || this.y.contains(p1.y.to)));
    };
    /**
     * Check if 'this' is partially outside the boundaries of 'position'
     *
     */
    Rect.prototype.isOverflowing = function (position) {
        return (!this.x.contains(position.x.from) ||
            !this.x.contains(position.x.to) ||
            !this.y.contains(position.y.from) ||
            !this.y.contains(position.y.to));
    };
    Rect.prototype.withPadding = function (padding) {
        if (!padding) {
            throw ArgumentNullError.fromName("padding");
        }
        var left = padding.left, right = padding.right, bottom = padding.bottom, top = padding.top;
        return new Rect({
            x: new Range({
                from: left ? left + this.x.from : this.x.from,
                to: right ? this.x.to - right : this.x.to
            }),
            y: new Range({
                from: bottom ? bottom + this.y.from : this.y.from,
                to: top ? this.y.to - top : this.y.to
            })
        });
    };
    Rect.prototype.add = function (size) {
        return new Rect({
            x: new Range({
                from: this.x.from - (size.left || 0),
                to: this.x.to + (size.right || 0)
            }),
            y: new Range({
                from: this.y.from - (size.bottom || 0),
                to: this.y.to + (size.top || 0)
            })
        });
    };
    Rect.prototype.toSized = function () {
        return {
            x: this.x.from,
            y: this.y.from,
            width: this.x.to - this.x.from,
            height: this.y.to - this.y.from
        };
    };
    return Rect;
}());
export { Rect };
export var Position = Rect;
export var Axis;
(function (Axis) {
    Axis["horizontal"] = "horizontal";
    Axis["vertical"] = "vertical";
})(Axis || (Axis = {}));
var Padding = /** @class */ (function () {
    function Padding() {
    }
    Padding.zero = {
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
    return Padding;
}());
export { Padding };



//////////////////
// WEBPACK FOOTER
// ../plano/dist/position.js
// module id = 976
// module chunks = 0